import { Link } from 'react-router';

export function Terms() {
  return (
    <div className="landing" style={{ alignItems: 'start' }}><div className="panel" style={{ maxWidth: 760, color: 'var(--ink)' }}>
      <h1>Terms and community rules (beta)</h1>
      <p className="muted">The short version: be kind, play fair, and remember it's a beta. Last updated 8 October 2026.</p>

      <h2>Community rules</h2>
      <ul>
        <li><b>Be kind.</b> No bullying, threats, hate or harassment, in usernames, display names, bios, or anywhere else.</li>
        <li><b>Keep it clean.</b> Lots of players are kids. Nothing rude, scary or adult in anything you write or upload.</li>
        <li><b>Play fair.</b> No cheats, bots, scripts, exploiting bugs, or using several accounts to farm credits or rig matches. Found a bug? Use the feedback button. We're grateful, not cross.</li>
        <li><b>Keep yourself safe.</b> Don't share your real name, address, school, phone number or passwords, and never meet up with someone you only know from the game.</li>
        <li><b>Only upload your own photos</b> of real Gooflord cards.</li>
      </ul>
      <p>Staff can hide players who break these rules from everyone else, take back cards or credits gained by cheating, and close accounts. If someone's breaking them, tell us with the 🐛 feedback button or email <a href="mailto:hello@gooflord.online">hello@gooflord.online</a>.</p>

      <h2>Your account</h2>
      <p>One account per person. Keep your password to yourself. You're responsible for what happens on your account. If you're under 18, a parent or guardian needs to know you're playing. You can delete your account at any time from the Profile page.</p>

      <h2>Cards, credits and packs</h2>
      <p>Credits, cards and cosmetics are part of the game. They have no money value, can't be swapped for real money or sold outside the game, and belong to the game rather than to you. During the beta we may rebalance cards, change prices or odds (always published in the app), or reset progress if we have to. We'll tell you first where we can.</p>

      <h2>Ben's game</h2>
      <p>Gooflord, its cards, art and names belong to their creator. You can share screenshots and videos of your games. Please don't copy the cards or art for anything else without asking.</p>

      <h2>The beta</h2>
      <p>This is a test version. Things will break, and the game may be down or change without notice. We provide it as is, and as far as the law allows we aren't liable for lost progress or other losses from using it. Nothing here takes away rights you have under the Australian Consumer Law.</p>

      <h2>Contact</h2>
      <p>Questions, appeals, or anything else: <a href="mailto:hello@gooflord.online">hello@gooflord.online</a>. Privacy requests: <a href="mailto:privacy@gooflord.online">privacy@gooflord.online</a>. See also the <Link to="/privacy">privacy notice</Link>.</p>
      <p><Link className="btn" to="/">Back</Link></p>
    </div></div>
  );
}
